import React from 'react';

const GameDetailsSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-900 animate-pulse">
      {/* Header skeleton */}
      <div className="fixed top-16 left-0 right-0 z-40 bg-white dark:bg-dark-800 shadow-sm border-b border-gray-200 dark:border-dark-700">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded w-20"></div>
        </div>
      </div>

      <div className="pt-32">
        <div className="max-w-6xl mx-auto px-4">
          {/* Hero section skeleton */}
          <div className="bg-white dark:bg-dark-800 rounded-lg shadow-lg overflow-hidden mb-8">
            <div className="md:flex">
              {/* Image skeleton */}
              <div className="md:w-1/3">
                <div className="w-full h-64 md:h-96 bg-gray-300 dark:bg-dark-700"></div>
              </div>
              
              {/* Content skeleton */}
              <div className="md:w-2/3 p-6">
                {/* Title skeleton */}
                <div className="h-8 bg-gray-300 dark:bg-dark-700 rounded mb-4"></div>
                <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded w-3/4 mb-6"></div>
                
                {/* Description skeleton */}
                <div className="space-y-3 mb-6">
                  <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded"></div>
                  <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded"></div>
                  <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded w-5/6"></div>
                </div>
                
                {/* Tags skeleton */}
                <div className="flex flex-wrap gap-2 mb-6">
                  <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded-full w-16"></div>
                  <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded-full w-20"></div>
                  <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded-full w-14"></div>
                </div>
                
                {/* Buttons skeleton */}
                <div className="flex gap-4">
                  <div className="h-12 bg-gray-300 dark:bg-dark-700 rounded w-32"></div>
                  <div className="h-12 bg-gray-300 dark:bg-dark-700 rounded w-28"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Details sections skeleton */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* System Requirements skeleton */}
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-lg p-6">
              <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded mb-4"></div>
              <div className="space-y-3">
                <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded"></div>
                <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded w-4/5"></div>
                <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded w-3/4"></div>
                <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded w-5/6"></div>
              </div>
            </div>

            {/* Game Info skeleton */}
            <div className="bg-white dark:bg-dark-800 rounded-lg shadow-lg p-6">
              <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded mb-4"></div>
              <div className="space-y-3">
                <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded"></div>
                <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded w-4/5"></div>
                <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded w-3/4"></div>
                <div className="h-4 bg-gray-300 dark:bg-dark-700 rounded w-5/6"></div>
              </div>
            </div>
          </div>

          {/* Screenshots skeleton */}
          <div className="bg-white dark:bg-dark-800 rounded-lg shadow-lg p-6 mt-8">
            <div className="h-6 bg-gray-300 dark:bg-dark-700 rounded mb-6"></div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {Array.from({ length: 8 }, (_, index) => (
                <div key={index} className="aspect-video bg-gray-300 dark:bg-dark-700 rounded"></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameDetailsSkeleton;

